import styled, { RuleSet } from 'styled-components'
import { Noto_body1_b16 } from 'src/styles/font/NotoSansKrFonts'

const DefaultButton = styled.button.attrs({ type: 'button' })<{
  $style?: RuleSet<object>
}>`
  ${Noto_body1_b16};
  height: 48px;
  line-height: 48px;
  border-radius: 12px;
  border: 1px solid var(--black-10);
  background-color: var(--white);
  color: var(--black-60);
  &:active {
    background-color: var(--black-4);
  }
  /* 활성화된 버튼 스타일 */
  &:not([disabled]) {
    cursor: pointer;
  }
  /* 비활성화된 버튼 스타일 */
  &:disabled {
    color: var(--black-30);
    background-color: var(--black-10);
    border: 1px solid var(--black-10);
    cursor: not-allowed;
  }
  ${(props) => props.$style};
`
const PrimaryButton = styled(DefaultButton).attrs({ type: 'button' })<{
  $style?: RuleSet<object>
}>`
  background-color: var(--brand-50);
  color: var(--white);
  border: 1px solid var(--brand-50);
  &:active {
    background-color: var(--brand-70);
  }
  /* 활성화된 버튼 스타일 */
  &:not([disabled]) {
    cursor: pointer;
  }
  /* 비활성화된 버튼 스타일 */
  &:disabled {
    color: var(--black-30);
    background-color: var(--black-10);
    border: 1px solid var(--black-10);
    cursor: not-allowed;
  }
  ${(props) => props.$style};
`
const SecondaryButton = styled(DefaultButton).attrs({ type: 'button' })<{
  $style?: RuleSet<object>
}>`
  background-color: var(--brand-10);
  border: 1px solid var(--brand-10);
  color: var(--brand-50);

  &:active {
    background-color: var(--brand-20);
    border: 1px solid var(--brand-20);
  }
  /* 활성화된 버튼 스타일 */
  &:not([disabled]) {
    cursor: pointer;
  }
  /* 비활성화된 버튼 스타일 */
  &:disabled {
    color: var(--black-20);
    background-color: var(--black-4);
    border: 1px solid var(--black-4);
    cursor: not-allowed;
  }
  ${(props) => props.$style};
`

export { DefaultButton, SecondaryButton, PrimaryButton }
